import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class AtLeastOneTeamWithExposureMoreThanZeroValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const exposureSumOfPrimaryStack = stacking.getExposureSumOfCheckedTeamsByStackNumber(
            Const.MLB_NON_CONTROLLED_FIRST_GROUP,
        );
        const exposureSumOfSecondaryStack = stacking.getExposureSumOfCheckedTeamsByStackNumber(
            Const.MLB_NON_CONTROLLED_SECOND_GROUP,
        );

        if (!exposureSumOfPrimaryStack || !exposureSumOfSecondaryStack) {
            this.addError('Should be at least one team with exposure more than 0.');
        }
    }
}

export default AtLeastOneTeamWithExposureMoreThanZeroValidator;
